import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { PanAppState, PlatformEnum, PlatformService } from '@panamax/app-state';
import { ImageVariantEnum } from 'src/app/product-detail/models/image-variant.enum';
import { ProductDetailViewModel } from 'src/app/product-detail/models/product-detail-view-model';
import { ProductDetailTagsService } from 'src/app/product-detail/services/product-detail-tags.service';
import {
  getCarouselImages,
  getFirstImageURL,
} from 'src/app/product-detail/utils/product-images.util';
import { TagProduct } from 'src/app/shared/components/usf-product-tag-list/models/tag-product.model';
import { ImageModel } from '@shared/models/image.model';

@Component({
  selector: 'app-product-header-card',
  templateUrl: './product-header-card.component.html',
  styleUrls: ['./product-header-card.component.scss'],
})
export class ProductHeaderCardComponent implements OnInit, OnChanges {
  @Input() product: ProductDetailViewModel;
  @Input() isGuestUser: boolean;

  thumbnailImageURL: string;
  alternativeImageUrl: ImageModel[];
  productTags: TagProduct[] = [];
  platformEnum = PlatformEnum;
  platformType: PlatformEnum;

  constructor(
    readonly platformService: PlatformService,
    readonly panAppState: PanAppState,
    private productDetailTagsService: ProductDetailTagsService,
  ) {}

  ngOnInit() {
    this.platformType = this.platformService.platformType;
    this.thumbnailImageURL = getFirstImageURL(
      this.product?.summary,
      ImageVariantEnum.Small,
    );
    this.alternativeImageUrl = getCarouselImages(this.product?.summary);
    if (this.product) {
      this.productTags = this.productDetailTagsService.getDisplayTags(
        this.product?.summary,
        this.product.inventory,
        this.product?.contract,
        this.product?.customerPill,
        this.product?.recentPurchase,
        this.product?.trackingAttributes,
        this.product?.resultRank,
        false,
        this.isGuestUser,
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue) {
      this.thumbnailImageURL = getFirstImageURL(
        this.product?.summary,
        ImageVariantEnum.Small,
      );
      this.alternativeImageUrl = getCarouselImages(this.product?.summary);
    }
  }

  getAlternativeThumbnail(imageUrl: string): string {
    const availImages = this.alternativeImageUrl?.find(
      (v, i) => v.urls.Thumbnail != imageUrl,
    );
    return availImages?.urls.Thumbnail;
  }
}
